<template>
  <div class="footer">
      <div class="foot hc-container">
        <div class="foot-l">
          <img src="@/assets/images/flogo.png" alt="">
          <ul>
            <li>邮编：215002 </li>
            <li>E-mail：amtf@honghuashe.com</li>
            <li>电话：0512-67531743（AM8:30—PM16:30接听）</li>
            <li>社址：苏州人民路穿心街三号 苏州弘化社慈善基金会</li>
            <li>版权所有 © 苏州弘化社慈善基金会</li>
          </ul>
       
    </div>
    <div class="foot-r">
        <dl>
          <dt>自媒体矩阵：</dt>
          <dd>
            <img src="@/assets/images/f12.png" alt="">
            <b>微信订阅号</b>
          </dd>
          <dd>
            <img src="@/assets/images/f13.png" alt="">
            <b>微信服务号</b>
          </dd>
          <dd>
            <img src="@/assets/images/f14.png" alt="">
            <b>官方头条</b>
          </dd>
          <dd>
            <img src="@/assets/images/f15.png" alt="">
            <b>官方微博</b>
          </dd>
        </dl>
        <div class="foot-r-b">
          <b>分享到：</b>
          <img src="@/assets/images/f16.png" alt="">
          <img src="@/assets/images/f17.png" alt="">
          <img src="@/assets/images/f18.png" alt="">
        </div>
      
    </div>
      </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
  components: {},
};
</script>

<style scoped lang="less">
.footer{
  width: 100%;
  height: 323px;
  background: url(../../assets/images/footer_bg.png) no-repeat top center;
  background-size: cover;
  .foot{
    display: flex;
    justify-content: space-between;
    padding: 40px 0px;
    &-l{
      ul{
        margin-top: 20px;
        li{
          line-height: 2;
        }
      }
    }
    &-r{
      display: flex;
      flex-direction: column;
      padding-top: 30px;
      dl{
        display: flex;
        justify-content: space-between;
        dt{font-weight: bold;color: #333;}
        dd{
          margin-left: 15px;
          line-height: 2;
          text-align: center;
          cursor: pointer;
        }
      }
      &-b{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: 30px;
        img{margin-left: 20px;cursor: pointer;}
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue